var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"zcard"}},[_c('ul',{staticClass:"nav flex-box"},_vm._l((_vm.nav),function(n,index){return _c('li',{key:index,class:{ac:_vm.see === index},on:{"click":function($event){_vm.see = index}}},[_vm._v(_vm._s(n)+"(0)")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }